import { useDeleteGroupMutation } from '../../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useRemoveGroupHandler( options?: any ) {
	const [ removeGroupMutation ] = useDeleteGroupMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( group: { id: number } ) => {
		const groupId = group.id

		const result = await removeGroupMutation( { variables: { groupId } } )
		if ( result.data?.deleteGroup?.success ) {
			showSuccess( `deleteGroupSuccess${Date.now()}`, result.data?.deleteGroup?.message ?? 'Successfully removed group!' )
		} else {
			showError( `deleteGroupError${Date.now()}`, result.data?.deleteGroup?.message ?? 'Sorry, an error occurred' )
		}
	}
}
